import type {BioIconProps} from './common-types'

export function FlagIconByLocale({locale, ...attributes}: BioIconProps) {
  switch (locale?.toLowerCase()) {
    case 'de':
      return (
        <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
          <g filter="url(#filter0_dd_1910_13141)">
            <g clipPath="url(#clip0_1910_13141)">
              <rect x="3" y="2" width="32" height="23" rx="3" fill="#F93939" />
              <path fillRule="evenodd" clipRule="evenodd" d="M3 17.3334H35V25H3V17.3334Z" fill="#FFDA2C" />
              <path fillRule="evenodd" clipRule="evenodd" d="M3 2H35V9.66667H3V2Z" fill="#151515" />
            </g>
            <rect x="3.5" y="2.5" width="31" height="22" rx="2.5" stroke="white" />
          </g>
          <defs>
            <filter
              id="filter0_dd_1910_13141"
              x="0"
              y="0"
              width="38"
              height="29"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1910_13141" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_1910_13141" result="effect2_dropShadow_1910_13141" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1910_13141" result="shape" />
            </filter>
            <clipPath id="clip0_1910_13141">
              <rect x="3" y="2" width="32" height="23" rx="3" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'fr':
      return (
        <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
          <g filter="url(#filter0_dd_1187_21097)">
            <g clipPath="url(#clip0_1187_21097)">
              <rect x="3" y="2.07141" width="32" height="22.8571" rx="3" fill="white" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.334 2.07141L35.0007 2.07141L35.0007 24.9286L24.334 24.9286L24.334 2.07141Z"
                fill="#F93939"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 2.07141L13.6667 2.07141L13.6667 24.9286L3 24.9286L3 2.07141Z"
                fill="#1A47B8"
              />
            </g>
            <rect x="3.5" y="2.57141" width="31" height="21.8571" rx="2.5" stroke="white" />
          </g>
          <defs>
            <filter
              id="filter0_dd_1187_21097"
              x="0"
              y="0.0714111"
              width="38"
              height="28.8572"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1187_21097" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_1187_21097" result="effect2_dropShadow_1187_21097" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1187_21097" result="shape" />
            </filter>
            <clipPath id="clip0_1187_21097">
              <rect x="3" y="2.07141" width="32" height="22.8571" rx="3" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'it':
      return (
        <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
          <mask id="mask0_222_28153" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="15">
            <path d="M21 0H0V15H21V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_222_28153)">
            <mask id="mask1_222_28153" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="15">
              <path
                d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_222_28153)">
              <path
                d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                fill="white"
              />
              <path fillRule="evenodd" clipRule="evenodd" d="M0 0H7V15H0V0Z" fill="#009342" />
              <path fillRule="evenodd" clipRule="evenodd" d="M14 0H21V15H14V0Z" fill="#D02832" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2C0 0.895428 0.895428 0 2 0H19C20.1045 0 21 0.895421 21 2V13C21 14.1045 20.1045 15 19 15H2C0.895421 15 0 14.1045 0 13V2ZM2 1C1.44771 1 1 1.44771 1 2V13C1 13.5523 1.44772 14 2 14H19C19.5523 14 20 13.5523 20 13V2C20 1.44772 19.5523 1 19 1H2Z"
                fill="black"
                fillOpacity="0.1"
              />
            </g>
          </g>
        </svg>
      )
    case 'uk':
      return (
        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
          <mask id="mask0_222_28123" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="16">
            <path d="M21 0.855469H0V15.8555H21V0.855469Z" fill="white" />
          </mask>
          <g mask="url(#mask0_222_28123)">
            <mask id="mask1_222_28123" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="16">
              <path
                d="M0 3.85547C0 2.19862 1.34315 0.855469 3 0.855469H18C19.6569 0.855469 21 2.19862 21 3.85547V12.8555C21 14.5124 19.6569 15.8555 18 15.8555H3C1.34315 15.8555 0 14.5124 0 12.8555V3.85547Z"
                fill="#D9D9D9"
              />
            </mask>
            <g mask="url(#mask1_222_28123)">
              <path d="M0 0.855469H21V15.8555H0V0.855469Z" fill="#1A47B8" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.23397 0.855469H0V3.35547L18.7539 15.8555H21V13.3555L2.23397 0.855469Z"
                fill="white"
              />
              <path d="M0.745098 0.855469L21 14.3909V15.8555H20.2724L0 2.30603V0.855469H0.745098Z" fill="#F93939" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 0.855469H21V3.35547C21 3.35547 8.0098 11.6836 2 15.8555H0V13.3555L19 0.855469Z"
                fill="white"
              />
              <path d="M21 0.855469H20.3218L0 14.4026V15.8555H0.745098L21 2.31698V0.855469Z" fill="#F93939" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.63708 0.855469H13.3804V5.48229H21V11.2256H13.3804V15.8555H7.63708V11.2256H0V5.48229H7.63708V0.855469Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.8421 0.855469H12.1579V6.6247H21V10.0862H12.1579V15.8555H8.8421V10.0862H0V6.6247H8.8421V0.855469Z"
                fill="#F93939"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 1.85547H3C1.89543 1.85547 1 2.7509 1 3.85547V12.8555C1 13.9601 1.89543 14.8555 3 14.8555H18C19.1046 14.8555 20 13.9601 20 12.8555V3.85547C20 2.7509 19.1046 1.85547 18 1.85547ZM3 0.855469C1.34315 0.855469 0 2.19862 0 3.85547V12.8555C0 14.5124 1.34315 15.8555 3 15.8555H18C19.6569 15.8555 21 14.5124 21 12.8555V3.85547C21 2.19862 19.6569 0.855469 18 0.855469H3Z"
                fill="black"
                fillOpacity="0.1"
              />
            </g>
          </g>
        </svg>
      )
    case 'in':
      return (
        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
          <g clipPath="url(#clip0_393_11965)">
            <mask id="mask0_393_11965" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="16">
              <path
                d="M19.1426 0.720703L2.14258 0.720703C1.03801 0.720703 0.142578 1.61613 0.142578 2.7207L0.142578 13.7207C0.142578 14.8253 1.03801 15.7207 2.14258 15.7207H19.1426C20.2471 15.7207 21.1426 14.8253 21.1426 13.7207V2.7207C21.1426 1.61613 20.2471 0.720703 19.1426 0.720703Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_393_11965)">
              <path
                d="M19.1426 0.720703L2.14258 0.720703C1.03801 0.720703 0.142578 1.61613 0.142578 2.7207L0.142578 13.7207C0.142578 14.8253 1.03801 15.7207 2.14258 15.7207H19.1426C20.2471 15.7207 21.1426 14.8253 21.1426 13.7207V2.7207C21.1426 1.61613 20.2471 0.720703 19.1426 0.720703Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6426 10.7207C12.0226 10.7207 13.1426 9.6007 13.1426 8.2207C13.1426 6.8407 12.0226 5.7207 10.6426 5.7207C9.26258 5.7207 8.14258 6.8407 8.14258 8.2207C8.14258 9.6007 9.26258 10.7207 10.6426 10.7207ZM10.6426 9.7207C11.4706 9.7207 12.1426 9.0487 12.1426 8.2207C12.1426 7.3927 11.4706 6.7207 10.6426 6.7207C9.81458 6.7207 9.14258 7.3927 9.14258 8.2207C9.14258 9.0487 9.81458 9.7207 10.6426 9.7207Z"
                fill="#00008A"
              />
              <path
                d="M10.6426 8.7207C10.9187 8.7207 11.1426 8.49685 11.1426 8.2207C11.1426 7.94456 10.9187 7.7207 10.6426 7.7207C10.3664 7.7207 10.1426 7.94456 10.1426 8.2207C10.1426 8.49685 10.3664 8.7207 10.6426 8.7207Z"
                fill="#00008A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.142578 10.7207H21.1426V15.7207H0.142578L0.142578 10.7207Z"
                fill="#018900"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.142578 0.720703L21.1426 0.720703V5.7207L0.142578 5.7207L0.142578 0.720703Z"
                fill="#FF991E"
              />
              <path
                d="M20.1426 2.7207C20.1426 2.16842 19.6949 1.7207 19.1426 1.7207L2.14258 1.7207C1.59029 1.7207 1.14258 2.16842 1.14258 2.7207L1.14258 13.7207C1.14258 14.273 1.59029 14.7207 2.14258 14.7207H19.1426C19.6949 14.7207 20.1426 14.273 20.1426 13.7207V2.7207ZM21.1426 13.7207C21.1426 14.8253 20.2471 15.7207 19.1426 15.7207H2.14258C1.03801 15.7207 0.142578 14.8253 0.142578 13.7207L0.142578 2.7207C0.142578 1.61613 1.03801 0.720703 2.14258 0.720703L19.1426 0.720703C20.2471 0.720703 21.1426 1.61613 21.1426 2.7207V13.7207Z"
                fill="black"
                fillOpacity="0.1"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_393_11965">
              <rect width="21" height="15" fill="white" transform="translate(0.142578 0.720703)" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'ca':
      return (
        <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
          <g clipPath="url(#clip0_204_22294)">
            <mask id="mask0_204_22294" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="15">
              <path d="M21 0H0V15H21V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_204_22294)">
              <mask id="mask1_204_22294" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="15">
                <path
                  d="M18 0H3C1.34315 0 0 1.34315 0 3V12C0 13.6569 1.34315 15 3 15H18C19.6569 15 21 13.6569 21 12V3C21 1.34315 19.6569 0 18 0Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1_204_22294)">
                <mask id="mask2_204_22294" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="15">
                  <path d="M21 0H0V15H21V0Z" fill="white" />
                </mask>
                <g mask="url(#mask2_204_22294)">
                  <mask id="mask3_204_22294" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="15">
                    <path
                      d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask3_204_22294)">
                    <path
                      d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 0H5V15H0V0ZM16 0H21V15H16V0ZM10.5 4L9.5 6L8 5V7L7 8L9 9H10V11H11V9H12L14 8L13 7V5L11.4 6L10.5 4Z"
                      fill="#FF0000"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0 2C0 0.895428 0.895428 0 2 0H19C20.1045 0 21 0.895421 21 2V13C21 14.1045 20.1045 15 19 15H2C0.895421 15 0 14.1045 0 13V2ZM2 1C1.44771 1 1 1.44771 1 2V13C1 13.5523 1.44772 14 2 14H19C19.5523 14 20 13.5523 20 13V2C20 1.44772 19.5523 1 19 1H2Z"
                      fill="black"
                      fillOpacity="0.1"
                    />
                  </g>
                </g>
              </g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 1C1.89543 1 1 1.89543 1 3V12C1 13.1046 1.89543 14 3 14H18C19.1046 14 20 13.1046 20 12V3C20 1.89543 19.1046 1 18 1H3ZM0 3C0 1.34315 1.34315 0 3 0H18C19.6569 0 21 1.34315 21 3V12C21 13.6569 19.6569 15 18 15H3C1.34315 15 0 13.6569 0 12V3Z"
                fill="white"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_204_22294">
              <rect width="21" height="15" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    case 'au':
      return (
        <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
          <g filter="url(#filter0_dd_1563_24455)">
            <g clipPath="url(#clip0_1563_24455)">
              <rect x="3" y="2" width="32" height="23" rx="3" fill="#1A47B8" />
              <path
                d="M31.9524 2H6.04762C4.36447 2 3 3.37299 3 5.06667V21.9333C3 23.627 4.36447 25 6.04762 25H31.9524C33.6355 25 35 23.627 35 21.9333V5.06667C35 3.37299 33.6355 2 31.9524 2Z"
                fill="#1A47B8"
              />
              <path
                opacity="0.5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.0957 19.6333L10.6195 18.8666L11.3814 17.3333L12.1433 18.8666L13.6671 19.6333L12.1433 20.4L11.3814 21.9333L10.6195 20.4L9.0957 19.6333ZM24.3338 6.59998V8.13331H25.8576V6.59998H24.3338ZM28.9052 8.13331V9.66664H30.429V8.13331H28.9052ZM22.81 11.2V12.7333H24.3338V11.2H22.81ZM27.3814 12.7333V14.2666H28.9052V12.7333H27.3814ZM25.8576 17.3333V18.8666H27.3814V17.3333H25.8576Z"
                fill="white"
              />
              <path
                d="M16.7139 3.53333H6.04725C5.20567 3.53333 4.52344 4.21982 4.52344 5.06666V12.7333C4.52344 13.5802 5.20567 14.2667 6.04725 14.2667H16.7139C17.5555 14.2667 18.2377 13.5802 18.2377 12.7333V5.06666C18.2377 4.21982 17.5555 3.53333 16.7139 3.53333Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6183 9.66665H6.04688V8.13332H10.6183V5.06665H12.1421V8.13332H16.7135V9.66665H12.1421V12.7333H10.6183V9.66665ZM14.4278 11.2V12.7333H16.7135V11.2H14.4278ZM14.4278 5.06665V6.59998H16.7135V5.06665H14.4278ZM6.04688 11.2V12.7333H8.33259V11.2H6.04688ZM6.04688 5.06665V6.59998H8.33259V5.06665H6.04688Z"
                fill="#F93939"
              />
            </g>
            <rect x="3.5" y="2.5" width="31" height="22" rx="2.5" stroke="white" />
          </g>
          <defs>
            <filter
              id="filter0_dd_1563_24455"
              x="0"
              y="0"
              width="38"
              height="29"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1563_24455" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="1.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend mode="normal" in2="effect1_dropShadow_1563_24455" result="effect2_dropShadow_1563_24455" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1563_24455" result="shape" />
            </filter>
            <clipPath id="clip0_1563_24455">
              <rect x="3" y="2" width="32" height="23" rx="3" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )
    default:
      return null
  }
}
